// import { CarModel, ID, Response } from "../../../../../_metronic/helpers"

import { CarModel, ID, Response } from "../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Car = {
  id?: ID
  name?: string
  car_name?: string
  avatar?: string
  email?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type CarsQueryResponse = Response<Array<CarModel>>

export const initialCar: Car = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}
